import React, { useEffect, useState, useCallback } from "react";
import Spinner from "../../../components/spinner/Spinner";
import ProjectDataCard from "../../projectBoardList/components/ProjectDataCard";
import { Col, Form, Nav, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { faStar as solidStar } from "@fortawesome/free-solid-svg-icons";
import { faStar as regularStar } from "@fortawesome/free-regular-svg-icons";
import {
  archiveProject,
  unFavouriteProject,
  updateProjectSequence,
} from "../../../store/actions/projects/projects.action";
import LoginModal from "../../../components/LoginModal";
import SubscriptionModal from "../../../components/subscriptionModal";
import { authUser } from "../../../store/selectors/users/user.selector";
import styled from "styled-components";
import {
  createPageView,
  getUserDetail,
  getFavoriteProjectsSummary,
  getFavoriteProjectsPaginated,
  removePageFavorite,
  addPageFavorite,
  fetchPageFavorite,
} from "../../../store/actions/users/users.actions";
import { Link, useNavigate } from "react-router-dom";
import Search from "../../../components/searchBar/Search";
import "./index.css";
import { useFeatureAccess } from "../../../hooks/useFeatureAccess";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const StyledSection = styled.section`
  background-color: rgb(249, 249, 251);
  min-height: 751px;
`;

const DraggableItem = React.memo(({ 
  item, 
  index, 
  handleProjectDetailCLick, 
  handleArchive, 
  handleFavourite, 
  authenticatedUser, 
  setLoginModalShow, 
  setPaymentModalShow,
  dragLoading
}) => {
  return (
    <Draggable
      key={item.id}
      draggableId={item.id.toString()}
      index={index}
      isDragDisabled={dragLoading}
    >
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          style={{
            margin: "0 0 8px 0",
            minHeight: "50px",
            backgroundColor: "transparent",
            opacity: dragLoading ? 0.6 : 1,
            ...provided.draggableProps.style,
          }}
        >
          <ProjectDataCard
            key={item.id}
            handleProjectDetailCLick={handleProjectDetailCLick}
            handleArchive={handleArchive}
            handleFavourite={handleFavourite}
            {...item}
            isFavourite={true}
            authenticatedUser={authenticatedUser}
            setLoginModalShow={setLoginModalShow}
            setPaymentModalShow={setPaymentModalShow}
          />
        </div>
      )}
    </Draggable>
  );
});

const DroppableColumn = React.memo(({ 
  columnId, 
  column, 
  handleHeadingChange, 
  handleBlurChange,
  handleProjectDetailCLick,
  handleArchive,
  handleFavourite,
  authenticatedUser,
  setLoginModalShow,
  setPaymentModalShow,
  onLoadMore,
  favoriteProjectsSummary,
  dragLoading
}) => {
  return (
    <div className="column" key={columnId}>
      <div style={{ padding: 8 }}>
        <h2 className="heading">
          <Form.Control
            type="text"
            name={columnId}
            value={column.name}
            onChange={handleHeadingChange}
            onBlur={handleBlurChange}
          />
        </h2>
        <h4 className="heading-count" style={{ background: 'rgb(227, 227, 227)' }}>{favoriteProjectsSummary?.columns.find(column => column.key === columnId)?.items?.length}</h4>
        <Droppable droppableId={columnId.toString()} key={columnId}>
          {(provided, snapshot) => (
            <div
              {...provided.droppableProps}
              className="column-items-list"
              ref={provided.innerRef}
              style={{
                background: snapshot.isDraggingOver ? "lightblue" : "#e3e3e3",
                minHeight: "200px"
              }}
            >
              {column.items?.map((item, index) => (
                item && (
                  <DraggableItem
                    key={item.id}
                    item={item}
                    index={index}
                    handleProjectDetailCLick={handleProjectDetailCLick}
                    handleArchive={handleArchive}
                    handleFavourite={handleFavourite}
                    authenticatedUser={authenticatedUser}
                    setLoginModalShow={setLoginModalShow}
                    setPaymentModalShow={setPaymentModalShow}
                    dragLoading={dragLoading}
                  />
                )
              ))}
              {provided.placeholder}
              
              {favoriteProjectsSummary?.loading && 
                <div className="text-center">
                  <Spinner />
                </div>
              }

              {/* Load More Button */}
              {column.hasMore && (
                <div className="load-more-container">
                  <button
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => onLoadMore(columnId)}
                    disabled={column.loading || dragLoading}
                  >
                    {column.loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" />
                        Loading...
                      </>
                    ) : (
                      'Load More'
                    )}
                  </button>
                </div>
              )}
            </div>
          )}
        </Droppable>
      </div>
    </div>
  );
});

const ProjectFavorite = () => {
  const [taskStatus, setTaskStatus] = useState({
    leadQualified: {
      name: "Lead Qualified",
      items: [],
    },
    contactMade: {
      name: "Contact Made",
      items: [],
    },
    proposalSent: {
      name: "Proposal Sent",
      items: [],
    },
    negotiationsStarted: {
      name: "Negotiations Started",
      items: [],
    },
  });
  const {
    favouriteProjects,
    loading: favLoading,
    favoriteProjectsSummary,
    favoriteProjectsPaginated,
    error,
  } = useSelector((state) => state.projects);
  const { user } = useSelector((state) => state.auth);
  const { free_mode_count } = useSelector((state) => state.userFreeModeCount);
  const [loginModalShow, setLoginModalShow] = useState(false);
  const [paymentModalShow, setPaymentModalShow] = useState(false);
  const { user: userProfile } = useSelector(
    (state) => state.userDetails
  );
  const { hasFeatureAccess, enforceAccess } = useFeatureAccess("Project");
  const { isFavorite } = useSelector((state) => state.fetchPageFavorite);
  const authenticatedUser = useSelector(authUser());
  const price_id = process.env.REACT_APP_PROJECT_APP;
  const [columns, setColumns] = useState(taskStatus);
  const [updateColumns, setUpdateColumns] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [debouncedSearchValue, setDebouncedSearchValue] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const [isSearching, setIsSearching] = useState(true);
  const [dragLoading, setDragLoading] = useState(false);
  const [lastUnfavoritedProject, setLastUnfavoritedProject] = useState(null);
  const [originalColumnsBeforeUnfavorite, setOriginalColumnsBeforeUnfavorite] = useState(null);
  const [originalColumnsSummaryBeforeUnfavorite, setOriginalColumnsSummaryBeforeUnfavorite] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleProjectDetailCLick = useCallback((e, link, created_by_users) => {
    e.preventDefault();
    if (!user) {
      setLoginModalShow(true);
    } else if (!hasFeatureAccess) {
      enforceAccess();
    } else if (created_by_users) {
      window.open(link, "_self");
    } else {
      window.open(link, "_self");
    }
  }, [user, price_id, free_mode_count, enforceAccess, hasFeatureAccess]);

  const handleArchive = useCallback((e, id) => {
    e.stopPropagation();
    e.preventDefault();
    dispatch(archiveProject(id));
  }, [dispatch]);

  const handleFavoriteToggle = () => {
    if (isFavorite) {
      dispatch(removePageFavorite({ page_name: "Pipeline" }));
    } else {
      dispatch(
        addPageFavorite({ page_name: "Pipeline", page_url: path })
      );
    }
  };
  
  const handleFavourite = useCallback(async (e, type, id) => {
    e.stopPropagation();
    e.preventDefault();
    if (!user) {
      setLoginModalShow(true);
    } else if (!hasFeatureAccess) {
      enforceAccess();
    } else {
      const originalColumns = { ...columns };
      await dispatch(unFavouriteProject(id));
      setOriginalColumnsBeforeUnfavorite(originalColumns);
      setOriginalColumnsSummaryBeforeUnfavorite(favoriteProjectsSummary.columns);
      setLastUnfavoritedProject(id);
      
      setColumns(prevColumns => {
        const updatedColumns = {};
        Object.keys(prevColumns).forEach(columnKey => {
          updatedColumns[columnKey] = {
            ...prevColumns[columnKey],
            items: prevColumns[columnKey].items.filter(item => item.id !== id)
          };
        });
        return updatedColumns;
      });
      
      Object.keys(columns).forEach(columnKey => {
        const column = columns[columnKey];
        const updatedItems = column.items.filter(item => item.id !== id);
        if (updatedItems.length !== column.items.length) {
          dispatch({
            type: 'UPDATE_FAVORITE_PROJECTS_LOCAL',
            payload: {
              column: columnKey,
              data: {
                results: {
                  projects: updatedItems
                }
              }
            }
          });
        }
      });
      const updatedColumns = favoriteProjectsSummary.columns.map(col => {
        return { ...col, items: col.items.filter(item => item !== id) };
      });
      dispatch({
        type: 'UPDATE_FAVORITE_PROJECTS_SUMMARY_LOCAL',
        payload: {
          columns: updatedColumns
        }
      });
    }
  }, [user, price_id, free_mode_count, dispatch, columns, hasFeatureAccess, enforceAccess]);
  
  useEffect(() => {
    if (error && lastUnfavoritedProject && originalColumnsBeforeUnfavorite) {
      setColumns(originalColumnsBeforeUnfavorite);
      
      Object.keys(originalColumnsBeforeUnfavorite).forEach(columnKey => {
        const column = originalColumnsBeforeUnfavorite[columnKey];
        dispatch({
          type: 'UPDATE_FAVORITE_PROJECTS_LOCAL',
          payload: {
            column: columnKey,
            data: {
              results: {
                projects: column.items
              }
            }
          }
        });
      });
      dispatch({
        type: 'UPDATE_FAVORITE_PROJECTS_SUMMARY_LOCAL',
        payload: {
          columns: originalColumnsSummaryBeforeUnfavorite
        }
      });
      setLastUnfavoritedProject(null);
      setOriginalColumnsBeforeUnfavorite(null);
      setOriginalColumnsSummaryBeforeUnfavorite(null);
    }
  }, [error, lastUnfavoritedProject, originalColumnsBeforeUnfavorite, dispatch]);

  // Debounce search input
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchValue(searchValue);
    }, 500); // 500ms delay

    return () => clearTimeout(timer);
  }, [searchValue]);

  // Search functionality
  const handleSearchChange = useCallback((e) => {
    setSearchValue(e.target.value);
  }, []);

  const handleShowSearch = useCallback(() => {
    setShowSearch(!showSearch);
  }, [showSearch]);

  const handleSearch = useCallback((e) => {
    e.preventDefault();
    // Immediately trigger search on form submit
    setDebouncedSearchValue(searchValue);
  }, [searchValue]);

  const handleClearSearch = useCallback(() => {
    setSearchValue("");
    setDebouncedSearchValue("");
    setIsSearching(true);
  }, []);

  const onDragEnd = useCallback(async (result) => {
    if (!result.destination || isSearching || dragLoading) return;
    
    setDragLoading(true);
    
    const { source, destination } = result;
    let columnn = {};

    const sourceColumnSummary = favoriteProjectsSummary.columns.find(col => col.key === source.droppableId);
    const destColumnSummary = favoriteProjectsSummary.columns.find(col => col.key === destination.droppableId);

    const sourceProjectMap = {};
    const destProjectMap = {};
    
    let sourceItems = [];
    let destItems = [];
    
    if (source.droppableId !== destination.droppableId) {
      const sourceColumn = columns[source.droppableId];
      const destColumn = columns[destination.droppableId];
      
      sourceColumn.items.forEach(item => { sourceProjectMap[item.id] = item });
      destColumn.items.forEach(item => { destProjectMap[item.id] = item });
      
      sourceItems = [...sourceColumnSummary.items];
      destItems = [...destColumnSummary.items];
      
      const [removed] = sourceItems.splice(source.index, 1);
      destItems.splice(destination.index, 0, removed);
      
      const sourceItemsWithDetails = sourceItems.map(id => sourceProjectMap[id]).filter(Boolean);
      
      const destItemsWithDetails = destItems.map(id => destProjectMap[id]).filter(Boolean);
      
      const movedItem = sourceProjectMap[removed];
      if (movedItem) {
        destItemsWithDetails.splice(destination.index, 0, movedItem);
      }
      
      columnn = {
        ...columns,
        [source.droppableId]: {
          ...sourceColumn,
          items: sourceItemsWithDetails,
        },
        [destination.droppableId]: {
          ...destColumn,
          items: destItemsWithDetails,
        },
      };
    } else {
      const column = columns[source.droppableId];
      
      column.items.forEach(item => { sourceProjectMap[item.id] = item });
      
      sourceItems = [...sourceColumnSummary.items];
      const [removed] = sourceItems.splice(source.index, 1);
      sourceItems.splice(destination.index, 0, removed);
      
      const copiedItemsWithDetails = sourceItems.map(id => sourceProjectMap[id]).filter(Boolean);
      
      columnn = {
        ...columns,
        [source.droppableId]: {
          ...column,
          items: copiedItemsWithDetails,
        },
      };
    }
    setColumns(columnn);
    
    const new_columns = {
      leadQualified: {
        ...columnn.leadQualified,
        items: source.droppableId === 'leadQualified' ? sourceItems 
          : destination.droppableId === 'leadQualified' ? destItems
          : favoriteProjectsSummary.columns.find(col => col.key === 'leadQualified')?.items || [],
      },
      contactMade: {
        ...columnn.contactMade,
        items: source.droppableId === 'contactMade' ? sourceItems 
          : destination.droppableId === 'contactMade' ? destItems
          : favoriteProjectsSummary.columns.find(col => col.key === 'contactMade')?.items || [],
      },
      proposalSent: {
        ...columnn.proposalSent,
        items: source.droppableId === 'proposalSent' ? sourceItems 
          : destination.droppableId === 'proposalSent' ? destItems
          : favoriteProjectsSummary.columns.find(col => col.key === 'proposalSent')?.items || [],
      },
      negotiationsStarted: {
        ...columnn.negotiationsStarted,
        items: source.droppableId === 'negotiationsStarted' ? sourceItems 
          : destination.droppableId === 'negotiationsStarted' ? destItems
          : favoriteProjectsSummary.columns.find(col => col.key === 'negotiationsStarted')?.items || [],
      },
    };

    const updatedColumns = favoriteProjectsSummary.columns.map(col => {
      return { ...col, items: new_columns[col.key].items };
    });
    
    try {
      // Wait for the backend sequence update to complete
      await dispatch(updateProjectSequence(new_columns));
      
      dispatch({
        type: 'UPDATE_FAVORITE_PROJECTS_SUMMARY_LOCAL',
        payload: {
          columns: updatedColumns
        }
      });

      setUpdateColumns(true);
      // Reload source column data to ensure unique project IDs and proper pagination
      if (source.droppableId !== destination.droppableId) {
        const sourceColumnData = favoriteProjectsPaginated[source.droppableId];
        const destColumnData = favoriteProjectsPaginated[destination.droppableId];
        if (sourceColumnData) {
          // Reload the current page for the source column
          dispatch(getFavoriteProjectsPaginated(
            source.droppableId, 
            sourceColumnData.currentPage || 1, 
            10, 
            true, 
            debouncedSearchValue
          ));
        }
        
        if (destColumnData) {
          // Reload the current page for the destination column
          dispatch(getFavoriteProjectsPaginated(
            destination.droppableId, 
            destColumnData.currentPage || 1, 
            10, 
            true, 
            debouncedSearchValue
          ));
        }
      }
    } catch (error) {
      console.error('Error updating project sequence:', error);
    } finally {
      setDragLoading(false);
    }
  }, [columns, dispatch, isSearching, dragLoading, favoriteProjectsPaginated, debouncedSearchValue, favoriteProjectsSummary?.loading]);

  // Update Redux data when columns change
  useEffect(() => {
    if (updateColumns)
      if (Object.keys(columns).length > 0 && columns.leadQualified?.items) {
        // Update the favoriteProjectsPaginated Redux state with current column data
        Object.keys(columns).forEach(columnKey => {
          const column = columns[columnKey];
          if (column && column.items && favoriteProjectsPaginated[columnKey]) {
            // Dispatch action to update Redux state with current column items
            dispatch({
              type: 'UPDATE_FAVORITE_PROJECTS_LOCAL',
              payload: {
                column: columnKey,
                data: {
                  results: {
                    projects: column.items
                  }
                }
              }
            });
          }
        });
      }
    setUpdateColumns(false);
  }, [updateColumns]);

  const handleHeadingChange = useCallback((e) => {
    const { name, value } = e.target;
    setColumns((prevColumns) => ({
      ...prevColumns,
      [name]: {
        ...prevColumns[name],
        name: value,
      },
    }));
  }, []);

  const handleBlurChange = useCallback((e) => {
    const new_columns = {
      leadQualified: {
        ...columns.leadQualified,
        items: favoriteProjectsSummary.columns.find(col => col.key === 'leadQualified')?.items || [],
      },
      contactMade: {
        ...columns.contactMade,
        items: favoriteProjectsSummary.columns.find(col => col.key === 'contactMade')?.items || [],
      },
      proposalSent: {
        ...columns.proposalSent,
        items: favoriteProjectsSummary.columns.find(col => col.key === 'proposalSent')?.items || [],
      },
      negotiationsStarted: {
        ...columns.negotiationsStarted,
        items: favoriteProjectsSummary.columns.find(col => col.key === 'negotiationsStarted')?.items || [],
      },
    };

    dispatch(updateProjectSequence(new_columns));
  }, [columns, dispatch, favoriteProjectsSummary]);

  useEffect(() => {
    dispatch(getUserDetail());
    // Load summary for column counts
    dispatch(getFavoriteProjectsSummary());
    dispatch(fetchPageFavorite("Pipeline"));
  }, [dispatch]);

  useEffect(() => {
    const projectFavorites = userProfile?.project_favorites;

    if (!projectFavorites) return;

    const projectMap = projectFavorites.reduce((acc, project) => {
      acc[project.id] = project;
      return acc;
    }, {});

    const updateColumnItems = (columnKey) => ({
      name:
        userProfile?.project_favorites_sequence?.[columnKey]?.name ||
        taskStatus?.[columnKey].name,
      items:
        userProfile?.project_favorites_sequence?.[columnKey]?.items
          ?.filter((item) => projectMap[item])
          .map((item) => projectMap[item]) || taskStatus?.[columnKey].items,
    });

    let updatedTaskStatus = Object.keys(columns).reduce(
      (acc, columnKey) => ({
        ...acc,
        [columnKey]: updateColumnItems(columnKey),
      }),
      {}
    );

    const modifiedProjects = projectFavorites.filter(
      (project) =>
        !Object.values(updatedTaskStatus).some((category) =>
          category.items?.some((hash) => hash.id === project.id)
        )
    );

    if (modifiedProjects.length > 0) {
      updatedTaskStatus = {
        ...updatedTaskStatus,
        leadQualified: {
          ...updatedTaskStatus.leadQualified,
          items: updatedTaskStatus.leadQualified.items.length
            ? [...updatedTaskStatus?.leadQualified?.items, ...modifiedProjects]
            : modifiedProjects,
        },
      };
    }

    setTaskStatus(updatedTaskStatus);
    setColumns(updatedTaskStatus);
  }, [userProfile?.project_favorites, userProfile?.project_favorites_sequence]);

  // Load paginated data when summary is available or search changes
  useEffect(() => {
    if (favoriteProjectsSummary.columns.length > 0) {
      setIsSearching(true);
      const searchPromises = favoriteProjectsSummary.columns
        .filter(col => col.count > 0)
        .map(col => dispatch(getFavoriteProjectsPaginated(col.key, 1, 10, false, debouncedSearchValue)));
      
      Promise.all(searchPromises).finally(() => {
        setIsSearching(false);
      });
    }
  }, [favoriteProjectsSummary.columns, dispatch, debouncedSearchValue]);

  // Update columns when paginated data loads
  useEffect(() => {
    if (favoriteProjectsSummary.columns.length > 0) {
      const updatedColumns = {};
      
      favoriteProjectsSummary.columns.forEach(col => {
        const paginatedData = favoriteProjectsPaginated[col.key];
        updatedColumns[col.key] = {
          name: col.name,
          items: paginatedData ? paginatedData.items : [],
          count: col.count,
          loading: paginatedData ? paginatedData.loading : false,
          hasMore: paginatedData ? paginatedData.hasMore : false
        };
      });
      
      setColumns(updatedColumns);
    }
  }, [favoriteProjectsSummary.columns, favoriteProjectsPaginated]);

  // Load more function for each column
  const loadMoreProjects = useCallback((columnKey) => {
    const column = favoriteProjectsPaginated[columnKey];
    if (column && column.hasMore && !column.loading && !isSearching && !dragLoading) {
      dispatch(getFavoriteProjectsPaginated(columnKey, column.currentPage + 1, 10, true, debouncedSearchValue));
    }
  }, [favoriteProjectsPaginated, dispatch, debouncedSearchValue, isSearching, dragLoading]);

  useEffect(() => {
    if (!favLoading) {
      navigate("/myganarpro/favorites");
    }
  }, [favouriteProjects, favLoading, navigate]);

  const path = window.location.pathname.slice(1);

  useEffect(() => {
    const pageRecord = "Pipeline";
    const type = "Pipeline";

    dispatch(createPageView(pageRecord, path, type));
  }, [dispatch, path]);

  return (
    <div>
      <div>
        <div className="container p-0">
          <div className="row">
            <div className="col-md-12 my-4">
              <Nav
                variant="underline"
                defaultActiveKey="/home"
                className="mx-5"
              >
                <Nav.Item>
                  <Nav.Link as={Link} to="/myganarpro/favorites">
                    Pipeline
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link as={Link} to="/myganarpro/hiddenProjects">
                    Hidden Projects
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link as={Link} to="/myganarpro/recentlyViewed">
                    Recently Viewed
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link as={Link} to="/myganarpro/savedSearches">
                    Saved Searches
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </div>
          </div>
        </div>
      </div>
      <div></div>
      <StyledSection>
        <div className="container py-5">
          <div className="row my-4">
            <div className="col-md-6 text-start">
              <div className="d-flex align-items-end gap-2">
                <div className="d-flex flex-column">
                  <Row>
                    <h2 className="col">Track deals in one place</h2>
                    {user && (
                      <Col sm={1}>
                        <FontAwesomeIcon
                          size={"2x"}
                          icon={isFavorite ? solidStar : regularStar}
                          style={{
                            color: isFavorite ? "gold" : "transparent",
                            stroke: isFavorite ? "" : "gold",
                            strokeWidth: isFavorite ? "0" : "20",
                            cursor: "pointer",
                          }}
                          onClick={handleFavoriteToggle}
                          className="fw-bolder"
                        />
                      </Col>
                    )}
                  </Row>
                  <h2>Create a custom pipeline, and never lose track of a sale again</h2>
                </div>
                <h2 className="fw-bolder fa-3xl">
                  ({favoriteProjectsSummary.total_projects || 0})
                </h2>
              </div>
            </div>
            <div className="col-md-6 text-start d-flex align-items-center justify-content-end gap-3">
              <Link to='/itb-import' className="btn btn-outline-primary fs-5">
                <i className="bi bi-envelope-plus me-2"></i>
                Import ITBs from Email
              </Link>
              <Link to='/create_deal' className="btn btn-primary fs-4">Create Deal</Link>
            </div>
          </div>
          
          {/* Search Bar */}
          <div className="row mb-4">
            <div className="col-md-8 d-flex align-items-center gap-2">
              <form onSubmit={handleSearch}>
                <Search
                  showSearchHandler={handleShowSearch}
                  activeSearch={true}
                  searchValue={searchValue}
                  handleSearchChange={handleSearchChange}
                  fillColor="#BBBBBB"
                  customClassInput="form-control py-3"
                  name="favorite-projects-search"
                  placeHolder="Search projects by name, location, company, or description..."
                  globalSearch={true}
                />
                {isSearching && (
                  <div className="position-absolute end-0 top-50 translate-middle-y me-3">
                    <div className="spinner-border spinner-border-sm text-primary" role="status">
                      <span className="visually-hidden">Searching...</span>
                    </div>
                  </div>
                )}
              </form>
              {(searchValue || debouncedSearchValue) && (
                  <div className="d-flex align-items-center gap-2">
                    {isSearching && (
                      <small className="text-muted d-flex align-items-center gap-1">
                        <div className="spinner-border spinner-border-sm" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                        Searching...
                      </small>
                    )}
                    <button 
                      type="button"
                      className="btn btn-outline-secondary btn-sm"
                      onClick={handleClearSearch}
                      disabled={isSearching}
                    >
                      Clear Search
                    </button>
                  </div>
                )}
            </div>
          </div>
            <div className="row">
              {favoriteProjectsSummary.loading ? (
                <div className="m-auto large-screen-pag">
                  <Spinner />
                </div>
              ) : (
                <div className="position-relative">
                  {/* Search Loading Overlay */}
                  {isSearching && (
                    <div className="position-absolute w-100 h-100 d-flex align-items-center justify-content-center bg-white bg-opacity-75" style={{ zIndex: 10 }}>
                      <div className="text-center">
                        <div className="spinner-border text-primary mb-2" role="status">
                          <span className="visually-hidden">Searching...</span>
                        </div>
                        <div className="text-muted">
                          {debouncedSearchValue ? `Searching for "${debouncedSearchValue}"...` : 'Loading...'}
                        </div>
                      </div>
                    </div>
                  )}
                  
                  {debouncedSearchValue && Object.values(columns).every(col => col.items?.length === 0) && !isSearching ? (
                    <div className="text-center py-5">
                      <h4 className="text-muted">No projects found</h4>
                      <p className="text-muted">
                        No projects match your search for "{debouncedSearchValue}". 
                        <button 
                          type="button"
                          className="btn btn-link p-0 ms-1 text-decoration-none"
                          onClick={handleClearSearch}
                        >
                          Clear search
                        </button> to see all projects.
                      </p>
                    </div>
                  ) : (
                    <div className="main-row col-sm-12 overflow-auto">
                      <DragDropContext onDragEnd={onDragEnd}>
                        {Object.entries(columns).map(([columnId, column]) => (
                          <DroppableColumn
                            key={columnId}
                            columnId={columnId}
                            column={column}
                            handleHeadingChange={handleHeadingChange}
                            handleBlurChange={handleBlurChange}
                            handleProjectDetailCLick={handleProjectDetailCLick}
                            handleArchive={handleArchive}
                            handleFavourite={handleFavourite}
                            authenticatedUser={authenticatedUser}
                            setLoginModalShow={setLoginModalShow}
                            setPaymentModalShow={setPaymentModalShow}
                            onLoadMore={loadMoreProjects}
                            favoriteProjectsSummary={favoriteProjectsSummary}
                            dragLoading={dragLoading}
                          />
                        ))}
                      </DragDropContext>
                      
                      {/* Drag Loading Overlay */}
                      {dragLoading && (
                        <div className="position-absolute w-100 h-100 d-flex align-items-center justify-content-center bg-white bg-opacity-75" style={{ zIndex: 10 }}>
                          <div className="text-center">
                            <div className="spinner-border text-primary mb-2" role="status">
                              <span className="visually-hidden">Updating...</span>
                            </div>
                            <div className="text-muted">Updating project position...</div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
          </div>

          <LoginModal
            show={loginModalShow}
            onHide={() => setLoginModalShow(false)}
          />
          <SubscriptionModal
            show={paymentModalShow}
            onHide={() => setPaymentModalShow(false)}
          />
        </div>
      </StyledSection>
    </div>
  );
};

export default ProjectFavorite;
